var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVoteInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.25 17.25V11.75C12.25 11.474 12.026 11.25 11.75 11.25H10.25",
    stroke: "#F49607",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25 8.75C12.9404 8.75 13.5 8.19036 13.5 7.5C13.5 6.80964 12.9404 6.25 12.25 6.25C11.5596 6.25 11 6.80964 11 7.5C11 8.19036 11.5596 8.75 12.25 8.75Z",
    fill: "#F49607"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.441 2.333C13.05 2.285 12.654 2.25 12.25 2.25C6.727 2.25 2.25 6.727 2.25 12.25C2.25 17.773 6.727 22.25 12.25 22.25C17.773 22.25 22.25 17.773 22.25 12.25C22.25 11.846 22.215 11.451 22.167 11.06",
    stroke: "#F49607",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.75 3.75L19.25 0.25L17.75 3.75L14.25 5.25L17.75 6.75L19.25 10.25L20.75 6.75L24.25 5.25L20.75 3.75Z",
    fill: "#F49607"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_392"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoteInfo);
export default __webpack_public_path__ + "static/media/vote-info.c155bf8c6c88d5ede462491b5d25c5f5.svg";
export { ForwardRef as ReactComponent };